import { render, staticRenderFns } from "./Kitchen.vue?vue&type=template&id=17d7d0e0&scoped=true&"
import script from "./Kitchen.vue?vue&type=script&lang=js&"
export * from "./Kitchen.vue?vue&type=script&lang=js&"
import style0 from "./Kitchen.vue?vue&type=style&index=0&id=17d7d0e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7d0e0",
  null
  
)

export default component.exports